import React from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import $ from "jquery"
import { Link } from 'react-router-dom';
import "../stylesheets/style.css"
import "../js/main.js"
const Faq = () => {

return(



    <div className='mobilerow'>
    <div className='container'>
       <div class="row">
           <div class="col-md-5">

               <div class="row">
                   <div class="col-md-1 col-2">
                       {/* <h2  className="line hmsecondboxtitle"></h2> */}
                       <img style={{paddingTop:"30px" }} className="" src="images/line.png"/>

                       </div>
                       <div class="col-md-11 col-10"  style={{paddingLeft:"25px" }}>
                       <h2 className=" hmsecondboxtitle fordesktoponly">  Not so sure? we can<br/> answer a few questions</h2>
                       <h2 className=" hmsecondboxtitle formobileonly">  Not so sure? we can<br/> answer a few questions</h2>

                       </div>
                       {/* <p className="hmseconddescription">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Penatibus tincidunt eget sit maecenas nam. </p> */}
                   

               </div>
               <img className="img-fluid hmsecondbox2 formobileonly" src="images/faq.png"/>
               <Accordion>
  <Accordion.Item eventKey="0">
    <Accordion.Header className="faqqheader">Where are the homes located?

</Accordion.Header>
    <Accordion.Body>

    Earth Vii Homes are located in prime areas, like Jahi, Mabushi, Life Camp, Dawaki and Katampe, which are mainly in the heart of Abuja.
- Oak Grandeur II is located at Jahi, Abuja


    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="1">
    <Accordion.Header className="faqqheader">Is there a flexible payment plan?

</Accordion.Header>
    <Accordion.Body>
    Yes, we have our off-plan on-plan payment plans which can be spread out over 3 to 12 months.

    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="2">
    <Accordion.Header className="faqqheader">What documents do I get after initial deposit?
</Accordion.Header>
    <Accordion.Body>
    An allocation letter with details of your payment plan will be presented after initial deposit is made.

    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="3">
    <Accordion.Header className="faqqheader">Can I move in after the first 40% deposit is made?
</Accordion.Header>
    <Accordion.Body>
    No, one can only move into the property after completion of payment

    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="4">
    <Accordion.Header className="faqqheader">Does Earth VII have an office 
</Accordion.Header>
    <Accordion.Body>
    Yes we do. Our office is located at Jahi Abuja 

    </Accordion.Body>
  </Accordion.Item>

  <Accordion.Item eventKey="5">
    <Accordion.Header className="faqqheader">How can I schedule a site Inspection?

</Accordion.Header>
    <Accordion.Body>
    You can schedule a site Inspection by filling this form here 


    </Accordion.Body>
  </Accordion.Item>


  <Accordion.Item eventKey="6">
    <Accordion.Header className="faqqheader">Who can I speak to for further assistance?


</Accordion.Header>
    <Accordion.Body>
    You can call us on 09016854815 or send an email to info@earthvii.org



    </Accordion.Body>
  </Accordion.Item>


</Accordion>
           </div>
           <div class="col-md-1"></div>
           <div class="col-md-6">
           <img className="img-fluid fordesktoponly" src="images/faq.png"/>
           </div>
       </div>
        </div>
    </div>


)

};


export default Faq;